// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3R4D8","options":"AnswerScale_options__W0_Xb","selected":"AnswerScale_selected__3TnO3"};